/** Lit la langue UI persistée (fr / ar) — utilisable hors LanguageProvider. */
export function readAppLanguage() {
  if (typeof window === 'undefined') return 'fr';
  try {
    const raw = window.localStorage?.getItem('appLanguage');
    if (raw === 'ar') return 'ar';
    if (raw === 'fr') return 'fr';
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed === 'ar' || parsed === 'fr') return parsed;
    }
  } catch {
    /* ignore */
  }
  return 'fr';
}
